import { render, staticRenderFns } from "./veStuRewardTypeEdit.vue?vue&type=template&id=2d8410da&scoped=true"
import script from "./veStuRewardTypeEdit.vue?vue&type=script&lang=js"
export * from "./veStuRewardTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8410da",
  null
  
)

export default component.exports